<template>
    <div>
        <div class="quantity mt-4">
            <div class="d-flex">
                <div class="container-quantity">
                    <span class="minus" v-on:click="sub()">-</span>
                    <input id="quantity" v-model.number="product.quantite" :data-article-id="item.id" class="form-control"
                            min="0" name="quantity" step="1" type="number">
                    <span class="more" v-on:click="add()">+</span>
                </div>
                <button class="btn btn-success add-to-cart" @click.prevent="updateCart" :disabled="existsInCart"><i
                    class="fas fa-shopping-cart"></i></button>
                <button class="btn btn-danger" type="reset" @click.prevent="removeFromCart"><i class="fas fa-trash-alt"></i></button>
            </div>
        </div>
    </div>
</template>


<script>
import {mapActions} from 'vuex'

export default {
    name: "CartQuantityAction",
    props: {
        item: Object,
        guest: {
            default: false,
            type: Boolean
        }
    },
    data() {
        return {
            product: null,
            existsInCart:false,
            currentTimeout: null
        }
    },
    created() {
        this.checkIfExist()
    },
    computed: {

    },
    methods: {
        ...mapActions("cart", {
            addItem: "add",
            removeItem: "delete",
        }),

        checkIfExist(){
            if(this.item && this.$store.state.cart.products.hasOwnProperty(this.item.id)){
                this.product = this.$store.state.cart.products[this.item.id]
                this.existsInCart = true
            } else {
                this.existsInCart = false
                this.product = {
                    article_id: this.item.id,
                    quantite: (this.item.qte) ? this.item.qte : 0,
                    source_type: 'catalogue'
                }
            }
        },

        add() {
            this.product.quantite++
            this.updateCart()
        },
        sub() {
            if (this.product.quantite > 0) {
                this.product.quantite--
                this.updateCart()
            }
        },

        updateCart() {
            if (this.product.quantite >= 0) {
                if(this.currentTimeout){
                    clearTimeout(this.currentTimeout)
                }

                this.currentTimeout = setTimeout(this.doUpdateCart, 300)
            }
        },
        doUpdateCart(){
            //TODO: show loader
            this.addItem(this.product).then(() => {
                this.checkIfExist()
               /* this.$store.dispatch('toast', {
                    type: 'success',
                    title: 'Votre panier a bien été mis à jour.',
                    message: ''
                });*/
            }).catch((error) => {
                console.log(error);
                this.$store.dispatch('dispatchError', error);
            }).finally(() => {
                //TODO: hide loader
            })
        },
        removeFromCart(){
            this.removeItem(this.product).then(() => {
                this.checkIfExist()
                /*this.$store.dispatch('toast', {
                    type: 'success',
                    title: 'Votre panier a bien été mis à jour.',
                    message: ''
                });*/
            }).catch((error) => {
                this.$store.dispatch('dispatchError', error);
            }).finally(() => {
                //TODO: hide loader
            })
        }
    }
}
</script>
